import { getNotificationTranslations } from '@common/i18n/notifications';
import { Button, Stack, Typography } from '@mui/material';
import useApsDiscoveryStore from '@/stores/useApsDiscoveryStore';
import { errorSnackbar, infoSnackbar, successSnackbar, warningSnackbar } from '@/utils/snackbar';

export default function FixturesTab() {
    const hasSeen = useApsDiscoveryStore((state) => state.hasSeen);
    const clearSeen = useApsDiscoveryStore((state) => state.clearSeen);

    return (
        <Stack spacing={3}>
            <Stack spacing={1} sx={{ maxWidth: '720px' }}>
                <Typography sx={{ fontWeight: 600, color: 'text.primary' }}>
                    APS data extraction discovery modal
                </Typography>
                <Typography variant="body2" sx={{ color: 'neutral.N_500' }}>
                    {hasSeen
                        ? 'This browser has already dismissed the modal, so it will not auto-show on load.'
                        : 'This browser has not dismissed the modal, so it will auto-show on load.'}
                </Typography>
                <Button
                    variant="outlined"
                    onClick={clearSeen}
                    disabled={!hasSeen}
                    sx={{ width: 'fit-content', textTransform: 'none' }}
                >
                    Clear seen flag
                </Button>
            </Stack>
            <Stack spacing={1} sx={{ maxWidth: '720px' }}>
                <Typography sx={{ fontWeight: 600, color: 'text.primary' }}>
                    Snackbar test
                </Typography>
                <Typography variant="body2" sx={{ color: 'neutral.N_500' }}>
                    Fire snackbars to check wrapping on a narrow viewport. The form-lock one is the
                    message that includes an email.
                </Typography>
                <Stack direction="row" flexWrap="wrap" gap={1}>
                    <Button
                        variant="outlined"
                        color="error"
                        sx={{ textTransform: 'none' }}
                        onClick={() =>
                            errorSnackbar(
                                getNotificationTranslations('en').formLockedBy(
                                    'very.long.client.name@somelawfirmexample.com',
                                ),
                            )
                        }
                    >
                        Form lock (email)
                    </Button>
                    <Button
                        variant="outlined"
                        color="error"
                        sx={{ textTransform: 'none' }}
                        onClick={() =>
                            errorSnackbar(getNotificationTranslations('en').emailNotRecognized)
                        }
                    >
                        Error
                    </Button>
                    <Button
                        variant="outlined"
                        color="success"
                        sx={{ textTransform: 'none' }}
                        onClick={() => successSnackbar('Form has been submitted.')}
                    >
                        Success
                    </Button>
                    <Button
                        variant="outlined"
                        color="warning"
                        sx={{ textTransform: 'none' }}
                        onClick={() => warningSnackbar('Please save before leaving.')}
                    >
                        Warning
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{ textTransform: 'none' }}
                        onClick={() => infoSnackbar('Copied link')}
                    >
                        Info
                    </Button>
                </Stack>
            </Stack>
        </Stack>
    );
}
